import { API, APICall } from '../Api'

export default {
  name: 'Announcements',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.Announcement.Get.Type,
        Endpoint: APICall.Announcement.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Announcement.Save.Type,
        Endpoint: APICall.Announcement.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.Announcement.List.Type,
        Endpoint: APICall.Announcement.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allDealerGroups (data) {
      const Request = {
        Type    : APICall.Dealer.Group.List.Type,
        Endpoint: APICall.Dealer.Group.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allDealerGroupsFilter () {
      const Request = {
        Type    : APICall.Dealer.Group.Filters.Type,
        Endpoint: APICall.Dealer.Group.Filters.Endpoint,
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allDealers (data) {
      const Request = {
        Type    : APICall.Dealer.List.Type,
        Endpoint: APICall.Dealer.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async dealerFilters (data) {
      const Request = {
        Type    : APICall.Dealer.Filters.Type,
        Endpoint: APICall.Dealer.Filters.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
